'use client';

import type { UniversalSearchTabInfo, UniversalSearchTabItemInfo } from '@weberus/shared-types';
import { TextButton } from '@yanolja-rnd/nol-design-system';
import { IcDone } from '@yanolja-rnd/nol-icons';
import { useEffect } from 'react';
import { cn } from '@/app/_shared/utils/tw-cn';
import { NewBadge } from '@/app/(pages)/results/(pages)/ui/search-header/vertical-tab';

interface CategoryOverviewMenuProps {
  data: UniversalSearchTabInfo['items'];
  isOpen: boolean;
  onClickItem: (item: UniversalSearchTabItemInfo) => void;
  onClose: () => void;
  headerHeight: number;
}

export const CategoryOverviewMenu = ({
  data,
  isOpen,
  onClickItem,
  onClose,
  headerHeight,
}: CategoryOverviewMenuProps) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  if (!isOpen) return;

  return (
    <>
      {/* Dim 배경 오버레이 - 드롭다운이 열려있을 때만 표시 */}
      <div
        className="fixed inset-0 bottom-0 left-0 right-0 z-30 animate-fadeIn bg-static-black bg-opacity-50 pc:hidden"
        style={{
          top: `${Math.max(headerHeight + 2, 120)}px`,
          animationDuration: '0.2s',
        }}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          onClose();
        }}
        onTouchStart={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
      />
      <div className="absolute left-0 right-0 z-50 overflow-hidden pc:hidden" style={{ top: 120 }}>
        <div className="animate-categoryOverviewClose overflow-hidden bg-static-white">
          <div className="m-16">
            {data?.map((item) => (
              <div key={item.key} className="mb-4 flex w-full">
                <TextButton
                  className={cn(
                    `h-48 w-full justify-between gap-8 rounded-8 px-12 text-left ${item.selected ? 'bg-fill-neutral-weak text-text-neutral-main !typography-subtitle-16-bold' : '!typography-subtitle-16-regular'}`,
                  )}
                  onClick={() => {
                    onClickItem(item);
                  }}>
                  <div className="flex flex-row">
                    {item.title}
                    {item.isNew && (
                      <span className="mb-9 ml-2">
                        <NewBadge />
                      </span>
                    )}
                  </div>
                  {item.selected && <IcDone className="text-primary ml-10 h-24 w-24 bg-transparent" />}
                </TextButton>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
